module.exports = __webpack_public_path__ + "img/1514713809.de5320b4.jpg";